import type { TrayFilterSegmentOption } from '../components/tray-filter-segment-row'

/** Any / Yes / No segments shared by every tray's tri-state filter rows (Placed, Tagged, Favorited). */
export const TRI_STATE_FILTER_OPTIONS: ReadonlyArray<
  TrayFilterSegmentOption<'any' | 'yes' | 'no'>
> = [
  { value: 'any', label: 'Any', ariaLabel: 'Any' },
  { value: 'yes', label: 'Yes', ariaLabel: 'Yes' },
  { value: 'no', label: 'No', ariaLabel: 'No' },
]
